import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { passwordRequirements, validatePassword } from "../utils/passwordPolicy";

export default function SetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) {
      setStatus("Invalid link. Missing verification token.");
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) return;

    if (password !== confirm) {
      setStatus("Passwords do not match.");
      return;
    }

    const passwordValidation = validatePassword(password);
    if (!passwordValidation.isValid) {
      setStatus(passwordValidation.error);
      return;
    }

    try {
      setLoading(true);
      await axios.post(
        process.env.REACT_APP_BACKEND_CONNECTION + "/admin/user-registration/set-password",
        { token, password },
        { headers: { "Content-Type": "application/json" } }
      );

      setStatus("Password set successfully! Redirecting to login...");
      setTimeout(() => navigate("/signin"), 1500);
    } catch (error) {
      console.error("Set password error:", error);
      setStatus(
        error.response?.data?.error || "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

return (
  <div className="default-container">
    <div className="default-box">
      <h2 className="default-title">
        <i className="fas fa-lock" /> Aseta Salasana
      </h2>

      {token ? (
        <form onSubmit={handleSubmit} className="default-form">
          <div className="set-password-field">
            <label>
              <i className="fas fa-shield-halved" /> Vahvistuslinkki
            </label>
            <input type="text" value="Link verified" readOnly />
          </div>

          <div className="set-password-field">
            <label>
              <i className="fas fa-key" /> Uusi Salasana
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Uusi salasana"
              required
            />
          </div>

          <div className="set-password-field">
            <label>
              <i className="fas fa-check-circle" /> Vahvista Salasana
            </label>
            <input
              type="password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              placeholder="Vahvista salasana"
              required
            />
          </div>

          <p className="password-requirements-text">
            Salasanavaatimukset: {passwordRequirements.join(", ")}.
          </p>

          <button type="submit" className="default-button" disabled={loading}>
            {loading ? (
              <>
                <i className="fas fa-spinner fa-spin" /> Tallennetaan...
              </>
            ) : (
              <> Vahvista Käyttäjä </>
            )}
          </button>
        </form>
      ) : (
        <p className="status-text error">
          <i className="fas fa-exclamation-circle" /> {status}
        </p>
      )}

      {status && token && (
        <p
          className={`status-text ${
            status.toLowerCase().includes("error") ||
            status.toLowerCase().includes("wrong") ||
            status.toLowerCase().includes("not")
              ? "error"
              : "success"}`}>
            <i
            className={
              status.toLowerCase().includes("error") ||
              status.toLowerCase().includes("wrong") ||
              status.toLowerCase().includes("not")
                ? "fas fa-exclamation-circle"
                : "fas fa-check-circle"
            } />{" "}
          {status}
        </p>
      )}
    </div>
  </div>
)}